import styled from 'styled-components';

export const Wrapper = styled.div`
  background: var(--whiteDark);
  height: 100%;
`;
